var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompleted = function SvgCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.262 0a.67.67 0 0 0-.516.258L4.379 8.883l-3.193-3.01a.637.637 0 0 0-.547-.179.726.726 0 0 0-.488.353c-.119.194-.17.438-.144.679a.98.98 0 0 0 .284.606l3.69 3.48c.14.132.313.198.488.187.175-.012.34-.1.468-.25l7.824-9.158a.983.983 0 0 0 .22-.467c.034-.18.023-.368-.031-.54a.91.91 0 0 0-.271-.424.643.643 0 0 0-.417-.16Z",
    fill: "currentColor"
  })));
};
export default SvgCompleted;